// Shared by both workers and the app. No imports: the worker build resolves only relative paths.
export const ASSET_CACHE = 'maxhome-assets';
export const META_CACHE = 'maxhome-sw-meta';
// Release records live in the meta cache under this synthetic URL.
export const RELEASES_KEY = '/__sw/releases.json';

export type ReleaseRecord = {
  release: string;
  files: string[];
  // False for the release currently being served.
  superseded: boolean;
};

const isReleaseRecord = (value: unknown): value is ReleaseRecord => {
  const record = value as Partial<ReleaseRecord> | null;
  return (
    typeof record?.release === 'string' &&
    Array.isArray(record.files) &&
    record.files.every((file) => typeof file === 'string') &&
    typeof record.superseded === 'boolean'
  );
};

// Null, not [], for unreadable data: [] would read as a first install and prune everything.
export const parseReleaseRecords = (data: unknown): ReleaseRecord[] | null =>
  Array.isArray(data) ? data.filter(isReleaseRecord) : null;
